module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": [1, 5, 10, 15, , 20],
      "layout": "total, sizes, prev, pager, next, jumper",
      "current-page": _vm.pageNum,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "small": _vm.small
    },
    on: {
      "size-change": _vm.sizeChange,
      "current-change": _vm.currentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0002c336!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination.vue
// module id = 316
// module chunks = 2